import Const from 'const';
import {ExposureTabs as MLBExposureTabs} from './sports/mlb/classic';
import {ExposureTabs as NFLExposureTabs} from './sports/nfl/classic';
import {ExposureTabs as LOLExposureTabs} from './sports/lol/classic';
import {ExposureTabs as NHLExposureTabs} from './sports/nhl/classic';

const classesMap = {
    [Const.LEAGUE_MLB]: {
        [Const.GAME_TYPE_CLASSIC]: MLBExposureTabs,
    },
    [Const.LEAGUE_NFL]: {
        [Const.GAME_TYPE_CLASSIC]: NFLExposureTabs,
    },
    [Const.LEAGUE_LOL]: {
        [Const.GAME_TYPE_CLASSIC]: LOLExposureTabs,
    },
    [Const.LEAGUE_NHL]: {
        [Const.GAME_TYPE_CLASSIC]: NHLExposureTabs,
    },
};

const Factory = {
    getComponent(sportConfig) {
        const sport = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        return classesMap[sport][gameType] || null;
    },
};

export {Factory};
